//components
import { PillLink } from '@/containers-ai/Buttons';
import { Grad } from '@/containers-ai/SectionHeading';

//styles
import {
  HeroSection,
  HeroInner,
  HeroCopy,
  HeroTitle,
  HeroSub,
  HeroNote,
} from './Hero.styles';

export function Hero() {
  return (
    <HeroSection id="top">
      <HeroInner>
        <HeroCopy>
          <HeroTitle>
            Loadsmart AI runs your freight. <br />
            <Grad>Freight Experts resolve the exceptions.</Grad>
          </HeroTitle>
          <HeroSub>
            Agents work with your system of record and when something needs a
            human, our Freight Experts step in.
          </HeroSub>
          <HeroNote>Shippers own the results. We own the work.</HeroNote>
          <PillLink href="#scenario-theater" className="qlf-btn-1">
            Watch it run your freight &#8594;
          </PillLink>
        </HeroCopy>
      </HeroInner>
    </HeroSection>
  );
}
